import { render } from "./classic_mb.html?vue&type=template&id=de1a2bca&scoped=true&external"
import script from "./ClassicPageMobile.vue?vue&type=script&lang=js"
export * from "./ClassicPageMobile.vue?vue&type=script&lang=js"

import "./style-mb-default.css?vue&type=style&index=0&id=de1a2bca&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de1a2bca"]])

export default __exports__